<template>
  <div class="selector-wrapper">
    <div class="value-head">
      <div>{{ values.min }}</div>
      <div>{{ values.max }}</div>
    </div>
    <div class="value-values">
      <div
        v-for="(value, idx) in values.range"
        :key="idx"
        :tabindex="idx"
        class="value-value"
        :title="CamelBackToSpace(value)"
        :data-testid="value"
        :class="values.selected === value ? 'selected' : ''"
        @click="handleChange(value)"
        @keydown="event => keyDownA11y(event, () => handleChange(value))"
      >
        {{ idx + 1 }}
      </div>
    </div>
  </div>
</template>

<script>
import { keyDownA11y } from '@/services/utils';

export default {
  props: ['values'],
  computed: {
    keyDownA11y() {
      return keyDownA11y;
    },
  },
  methods: {
    CamelBackToSpace(text) {
      if (!text) return '';
      return text
        .toString()
        .split(/(?=[A-Z])/)
        .join(' ');
    },
    async handleChange(e) {
      this.$emit('valueChanged', { action: this.values.action, agentName: this.values.agentName, value: e });
    },
  },
};
</script>

<style lang="scss" scoped>
.selector-wrapper {
  font-family: Gordita-Regular;
  font-size: 10px;
  line-height: 13px;
  padding: 12px 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: calc(100% - 20px);
  .value-head {
    color: #a0a0a0;
    display: flex;
    flex-direction: row;
    padding: 0px 4px 12px 4px;
    justify-content: space-between;
    justify-content: space-between;
    width: 100%;
  }
  .value-values {
    width: 100%;
    display: flex;
    cursor: pointer;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .value-value {
      &:hover {
        background: #ccfaea;
        border-radius: 24px;
        color: $-system-app-primary;
      }
      width: 32px;
      height: 32px;
      font-family: Gordita-Black;
      font-size: 13px;
      line-height: 17px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      color: #000000;
      &.selected {
        /* AppColors_dark green */
        background: $-system-app-primary;
        border-radius: 24px;
        /* AppColores_white */
        color: #ffffff;
      }
    }
  }
}
</style>
